import React from 'react'
import { useSelector } from 'react-redux';
import { AppState } from '../../../RootReducer';
import { MenuComponent, MenuComponentType, MenuPosition } from '../../../http/protocol';
import { LoginRegisterAbsolute, LoginRegisterFixed } from './SideMenuActions';
import CashbackComponent from './cashback/CashbackComponent';
import UserLevelComponent from './userlevel/UserLevelComponent';
import "../styles/MenuComponents.scss";


export interface SideMenuComponentsProps {
    position?: MenuPosition;
    onClose?: () => void;
    component?: MenuComponent;
}

/**
 * 
 * @returns 
 */
export default function SideMenuComponents(props: SideMenuComponentsProps) {
    const isLoggedIn = useSelector((app: AppState) => app.user.user?.loggedIn);
    const menuComponentType = isLoggedIn ? props.component?.loggedInComponent : props.component?.loggedOutComponent;

    switch (menuComponentType) {
        case MenuComponentType.LOGIN_REGISTER:
            return props.position == MenuPosition.ABSOLUTE ? <LoginRegisterAbsolute /> : <LoginRegisterFixed {...props} />;
        case MenuComponentType.USER_LEVEL:
            return <UserLevelComponent {...props} />;
        case MenuComponentType.CASHBACK:
            return <CashbackComponent {...props} />;
        case MenuComponentType.NONE:
            return <></>;
        default:
            return <></>;
    }
}
